import { render, staticRenderFns } from "./LsProperty.vue?vue&type=template&id=09a7c562&"
import script from "./LsProperty.vue?vue&type=script&lang=js&"
export * from "./LsProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports